import { FunctionComponent } from "react";

import { faChevronDoubleDown, faChevronDoubleUp } from "@fortawesome/pro-regular-svg-icons";

import { useTranslation } from "react-i18next";

import { Icon } from "@/components";
import {
	hasLeadScoringContent,
	LeadScoringInline,
} from "@/components/LeadScoringPopover/LeadScoringPopover";
import { toScoreLabel } from "@/components/LeadScoringPopover/scoreTier";

import { ListPerson } from "../../../schema/list";

interface LeadScoringSectionProps {
	listPerson: ListPerson;
}

export const LeadScoringSection: FunctionComponent<LeadScoringSectionProps> = ({ listPerson }) => {
	const { t } = useTranslation();
	const ts = (key: string) => t(`list.${key}`);
	const scoring = listPerson.prospect?.scorePersonaCategoryResult;

	if (!scoring || !hasLeadScoringContent(scoring)) {
		return null;
	}

	return (
		<details
			className="flex group w-full flex-col border border-gray-200 rounded-lg p-4"
			open={false}
		>
			<summary className="cursor-pointer flex bg-white flex-row items-start w-full justify-between gap-2">
				<h3 className="text-sm font-semibold text-gray-900">Lead Scoring Reasoning</h3>
				<div className="">
					<div className="flex flex-row gap-2 justify-center items-center text-sm group-open:hidden">
						<p>{ts("show.showMore")}</p>
						<Icon className="cursor-pointer text-sm w-3 h-3" icon={faChevronDoubleDown} />
					</div>
					<div className="flex flex-row gap-2 justify-center items-center text-sm hidden group-open:flex">
						<p>{ts("show.showLess")}</p>
						<Icon className="cursor-pointer text-sm w-3 h-3" icon={faChevronDoubleUp} />
					</div>
				</div>
			</summary>
			<div className="mt-4">
				<LeadScoringInline scoreLabel={toScoreLabel(scoring.overallScore)} scoring={scoring} />
			</div>
		</details>
	);
};
